export default __webpack_public_path__ + "static/media/093-right-arrow-1.e75d60e8.png";